// extracted by mini-css-extract-plugin
module.exports = {"caption":"caption-18SN_YHG","picTxt":"picTxt-2mo2M7Q-","abstract":"abstract-3Ex2e_ID","box_pic":"box_pic-3eUs8ui5 clearfix"};